import React,{ Component } from 'react'
import { MDBContainer,MDBNotification ,MDBView,MDBMask,MDBCol, MDBRow,MDBBtn,MDBIcon,MDBInput, MDBCard,MDBCardHeader, MDBCardBody, MDBCardTitle, MDBCardFooter} from 'mdbreact'

import { connect } from 'react-redux';
import {  signUp } from '../../../store/actions/auth/authActions'
import { Redirect } from 'react-router-dom'
import firebase from 'firebase'
import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LoginImg from '../../../assests/images/login.png'



  class signup extends Component {
    constructor(props) {
      super(props)
  
      this.state = { email : '',
      password : '',
      show: false,
      setShow:false }
    
           
  }

  handleChange = (e) => {
      console.log(e)
      this.setState({
          [e.target.id] : e.target.value
      })
  }
 
  handleSubmit = (e) => {
      console.log("handling signup")
     e.preventDefault();
    this.props.signUp(this.state)
 }
 

   render(){
    
    const { authError, auth,ret } = this.props
    if(ret) return <Redirect to='/' />
      return(
        <div>
        <section
         
        >
        <MDBView>
        <img
          src="https://mdbootstrap.com/img/new/fluid/city/008.jpg"
          className=""
          alt=""
        />
        <section > 

                              <MDBMask overlay="blue-strong">
                              <MDBRow className="m-5 p-4">
                                 <MDBCol sm="12" xs="">

                                 </MDBCol>
                                 </MDBRow>
                                <MDBRow className="p-3 my-5"
                                 style={{
                                   
                                 }}>
                               
                               <MDBCol md="6" sm="12" className="m-md-n5 text-center">
                                      <img src={LoginImg}  className="img-fluid"/ >
                                    </MDBCol>
                               <MDBCol md="6" sm="12" className="p-2 text-center">
                               
                                  
                                <MDBCard className="p-5">
                                <MDBCardHeader className="form-header deep-blue-gradient rounded" style={{marginTop: "-4.13rem"}}>
                                      <h4 className="my-2 text-center ">
                                        <MDBIcon icon="lock" className="" /> signup
                                      </h4>
                                    </MDBCardHeader>
                                    <MDBCardBody>
                                    <form  onSubmit={this.handleSubmit}>
                            
                                      <div className="grey-text">
                                      <MDBInput label="email"   group type="email" id="email" onChange={this.handleChange} validate error="wrong"
                                          dark="right" />
                                          <MDBInput label=" password"  group type="password"  id="password" onChange={this.handleChange} validate error="wrong"
                                          success="right"/>
                                            <MDBInput label="first name"   group type="text" id="firstName" onChange={this.handleChange} validate error="wrong"
                                          dark="right" />
                                            <MDBInput label="last name"   group type="text" id="lastName" onChange={this.handleChange} validate error="wrong"
                                          dark="right" />
                                          
                                      </div>
                                    
                                      <div className="text-center">
                                          <MDBBtn  rounded color="blue" style={{borderRadius:"25px"}} type="submit">
                                          signup
                                          <MDBIcon far icon="paper-plane" className="ml-1" />
                                          </MDBBtn>
                                      </div>
                                     
                                          </form>   
                                      <hr />
                                         
                                      
                                    </MDBCardBody>
                                    <MDBCardFooter className="bg-white m-n5">
                                      
                                      <p>already have account?  </p>
                                      <div className="red-text center">
                                      { authError ? <p> <MDBNotification   iconClassName="text-primary"   title="message" show fade message={authError} /></p> :null }
                                   </div>
                                    </MDBCardFooter>
                              </MDBCard>
                            
                               
                              </MDBCol>
                                </MDBRow>
                              </MDBMask>
                            </section>
                            </MDBView>

                </section>
              
              
            </div>

      )

 }
 }
    


 const mapStateToProps=(state)=>{
 return{
     authError : state.auth.authError,
     auth : state.firebase.auth,
     ret : state.auth.ret
 }
}


const mapDispatchToProps= (dispatch) =>
{
return {
    signUp : (creds) => dispatch(signUp(creds))
}
}



export default connect(mapStateToProps,mapDispatchToProps)(signup)